import { Component, h } from '@monygroupcorp/microact';

export class MessagePopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            messages: []
        };
    }

    show(options) {
        const { title = '', message = '', type = 'info', duration = 5000 } = options;
        const id = Date.now() + Math.random();

        const newMessage = { id, title, message, type };
        this.setState({ messages: [...this.state.messages, newMessage] });

        if (duration > 0) {
            setTimeout(() => this.close(id), duration);
        }
    }

    close(id) {
        const messages = this.state.messages.filter(msg => msg.id !== id);
        this.setState({ messages });
    }

    error(message, title = 'Error') {
        this.show({ title, message, type: 'error' });
    }

    success(message, title = 'Success') {
        this.show({ title, message, type: 'success' });
    }

    warning(message, title = 'Warning') {
        this.show({ title, message, type: 'warning' });
    }

    info(message, title = 'Info') {
        this.show({ title, message, type: 'info' });
    }

    handleClose(id) {
        this.close(id);
    }

    render() {
        const { messages } = this.state;

        return h('div', { id: 'message-popup-container' },
            messages.map(msg =>
                h('div', {
                    key: msg.id,
                    className: `message-popup ${msg.type}`,
                    'data-id': msg.id
                },
                    h('div', { className: 'message-content' },
                        msg.title && h('div', { className: 'message-title' }, msg.title),
                        h('div', { className: 'message-text' }, msg.message)
                    ),
                    h('button', {
                        className: 'close-button',
                        onClick: () => this.handleClose(msg.id)
                    }, '\u00D7')
                )
            )
        );
    }

    static get styles() {
        return `
            #message-popup-container {
                position: fixed;
                top: 20px;
                right: 20px;
                z-index: 10000;
                display: flex;
                flex-direction: column;
                gap: 10px;
            }

            .message-popup {
                background: #ffffff;
                border-radius: 8px;
                padding: 15px 20px;
                min-width: 300px;
                max-width: 400px;
                box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                animation: slideIn 0.3s ease;
                border-left: 4px solid #2196F3;
            }

            .message-popup.error {
                border-left-color: #f44336;
            }

            .message-popup.success {
                border-left-color: #4CAF50;
            }

            .message-popup.warning {
                border-left-color: #ff9800;
            }

            .message-content {
                flex-grow: 1;
                margin-right: 10px;
            }

            .message-title {
                font-weight: bold;
                margin-bottom: 5px;
            }

            .message-text {
                font-size: 14px;
                color: #666;
            }

            .close-button {
                background: none;
                border: none;
                color: #999;
                cursor: pointer;
                font-size: 20px;
                padding: 0;
                line-height: 1;
            }

            .close-button:hover {
                color: #666;
            }

            @keyframes slideIn {
                from {
                    transform: translateX(100%);
                    opacity: 0;
                }
                to {
                    transform: translateX(0);
                    opacity: 1;
                }
            }

            @keyframes fadeOut {
                from {
                    transform: translateX(0);
                    opacity: 1;
                }
                to {
                    transform: translateX(100%);
                    opacity: 0;
                }
            }
        `;
    }
}
